
import store from '@/store';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';
import StatusButton from './components/statusButton/StatusButton.vue';

@Component({
  components: {
    StatusButton,
  },
  computed: {
    ...mapState(['storeShowCategory', 'storeShowBfixCategory']),
  },
})
export default class StatusButtons extends Vue {
  @Prop({ type: Number, required: true }) private readonly allCounter!: number;
  @Prop({ type: Number, required: true }) private readonly unallocatedCounter!: number;
  @Prop({ type: Number, required: true }) private readonly progressCounter!: number;
  @Prop({ type: Number, required: true }) private readonly completedCounter!: number;
  @Prop({ type: Number, required: true }) private readonly cancelledCounter!: number;
  @Prop({ type: String, required: false, default: '' }) private readonly context!: string;

  private showCategory = 'progress';
  private storeShowCategory!: string;
  private storeShowBfixCategory!: string;
  private changeCategory(category: string): void {
    this.showCategory = category;
  }
  @Watch('showCategory')
  private setCategory() {
    if (this.context === 'bfix') {
      store.dispatch('setBfixCategory', this.showCategory);
    } else {
      store.dispatch('setCategory', this.showCategory);
    }
  }
  private mounted(): void {
    if (this.context === 'bfix') {
      this.showCategory = this.storeShowBfixCategory;
    } else {
      this.showCategory = this.storeShowCategory;
    }
  }
}
